import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'
import { InvoiceEvent } from '@features/invoices/types/invoices/invoiceEvent'

import { DEMO_INVOICE_CREATED_EVENT_OFFSET } from '../constants/demoInvoiceCreatedEventOffset'
import { DEMO_INVOICE_SEND_CHANNEL_TO_EVENT_TYPE } from '../constants/demoInvoiceSendChannelToEventType'
import { DemoInvoiceSendChannel } from '../enums/demoInvoiceSendChannel'

const getDemoInvoiceEvent = (eventType: InvoiceEventType, date: Date): InvoiceEvent => ({
  createdAt: date.toISOString(),
  eventData: null,
  eventType,
  processedAt: date.toISOString(),
})

export const getDemoInvoiceSentEvents = (sentAt: Date, channel: DemoInvoiceSendChannel): InvoiceEvent[] => [
  getDemoInvoiceEvent(DEMO_INVOICE_SEND_CHANNEL_TO_EVENT_TYPE[channel], sentAt),
  getDemoInvoiceEvent(InvoiceEventType.DocumentCreated, new Date(sentAt.getTime() - DEMO_INVOICE_CREATED_EVENT_OFFSET)),
]
